import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProducts } from '../../lib/shopify';
import ProductCard from '../product/ProductCard';
import { ArrowRight } from 'lucide-react';

const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getProducts();
        // Get first 4 products for featured section
        setProducts(data.products?.slice(0, 4) || []);
      } catch (error) {
        console.error('Error fetching featured products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <section data-testid="featured-products" className="py-20 md:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] font-accent text-xs uppercase tracking-[0.2em]">
            Our Jewellery
          </span>
          <h2 className="text-4xl md:text-5xl font-medium text-white mt-4 mb-4">
            Featured Pieces
          </h2>
          <div className="gold-divider mb-6" />
          <p className="text-white/60 max-w-2xl mx-auto">
            Discover our most loved pieces, each crafted with precision and designed to make 
            a statement. Waterproof, tarnish-free, and built to last.
          </p>
        </div>

        {/* Product Grid */}
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="aspect-square bg-[#111] mb-4" />
                <div className="h-4 bg-[#111] mb-2 w-3/4" />
                <div className="h-4 bg-[#111] w-1/4" />
              </div>
            ))}
          </div>
        ) : products.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-white/60">No products available at the moment.</p>
          </div>
        )}

        {/* View All Button */}
        <div className="text-center mt-16">
          <Link
            to="/jewellery"
            data-testid="view-all-products"
            className="btn-luxury-outline inline-flex items-center space-x-2"
          >
            <span>View All Jewellery</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
